import { render, staticRenderFns } from "./CreatorCommentsDrawer.vue?vue&type=template&id=c3cce036&scoped=true&"
import script from "./CreatorCommentsDrawer.vue?vue&type=script&lang=js&"
export * from "./CreatorCommentsDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CreatorCommentsDrawer.vue?vue&type=style&index=0&id=c3cce036&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3cce036",
  null
  
)

export default component.exports